import { useMemo } from 'react'
import { useClerk } from '@clerk/clerk-react'

export const useClerkEnvironment = () => {
  const { loaded, clerkjs } = useClerk() as any
  return useMemo(() => (loaded && clerkjs?.environment ? clerkjs.environment : {}), [loaded, clerkjs?.environment])
}
